import HARDCODE from '../../../business-const/HardCode/HardCode'

import AuthService from '../../../business-api/AuthService'

import ClienteService from '../../../business-api/ClienteService'

import {
    mensagemErroErro
} from '../../../business-components/Toastr/Toastr'

import {
    getBase64,
} from '../../../business-components/UploadFile/UploadFile'

import {
    putArquivoArquivoAcesso,
    deleteArquivoArquivoAcesso,
} from '../../arquivo/ArquivoService'



export const obtemArquivoProposta = (arquivoList, numeroProposta) => {

    let arquivoProposta = false

    arquivoList?.forEach( (item, ind) => {

        if (!arquivoProposta && item.numeroPropostaAcesso === numeroProposta) {

            arquivoProposta = item
        }
    })


    return arquivoProposta
}


export const obtemArquivoApolice = (arquivoList, numeroApolice) => {

    let arquivoApolice = false

    arquivoList?.forEach( (item, ind) => {

        if (!arquivoApolice && item.numeroApoliceAcesso === numeroApolice) {

            arquivoApolice = item
        }
    })


    return arquivoApolice
}



const converteType = (type) => {

    let typeConvertido = '?????????????????????'

    if (type === HARDCODE.PDFApplication) {

        typeConvertido = HARDCODE.PDF

    } else {

        if (type === HARDCODE.XLSXApplication) {

            typeConvertido = HARDCODE.XLSX

        } else {

            if (type === HARDCODE.PNGImage) {

                typeConvertido = HARDCODE.PNG
                
            } else {

                if (type === HARDCODE.JPEGImage) {

                    typeConvertido = HARDCODE.JPEG
                    
                }
            }
        }
    }

    return typeConvertido
}

export const carregarArquivoHistorico = async ( e, variaveisGlobais, values, vars, obterArquivoList,
    idTipoSolicitacaoArquivo, tipoSolicitacaoArquivo ) => {

    if (!AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)) {

        //setProcessing(true)

        const arquivos = e.target.files

        let indexArquivos = 0

        while (indexArquivos < arquivos.length) {

            try {

                const conteudo = await getBase64(arquivos[indexArquivos])

                const arquivoArquivoAcesso = {
                    idConfiguracaoOwner: vars.idConfiguracao,
                    idUsuarioOwner: ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                    grupoArquivo: HARDCODE.idGrupoArquivoClienteHistorico,
                    tipoArquivo: HARDCODE.idTipoArquivoClienteHistorico,
                    instituicaoFinanceira: null,
                    idTipoSolicitacaoArquivo: idTipoSolicitacaoArquivo,
                    tipoSolicitacaoArquivo: tipoSolicitacaoArquivo,
                    nomeArquivo: arquivos[indexArquivos].name,
                    extensaoArquivo: converteType(arquivos[indexArquivos].type),
                    statusProcessamento: HARDCODE.idStatusProcessamentoNaoSeAplica,
                    idUsuarioAcesso:  ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                    idClienteAcesso: values.id,
                }

                await putArquivoArquivoAcesso(variaveisGlobais, ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais),
                    arquivoArquivoAcesso, conteudo)

            } catch (erro) {

                mensagemErroErro(erro)
            }

            indexArquivos++
        }

        await obterArquivoList(values)

        //setProcessing(false)
    }
}

export const deletarArquivoArquivoAcesso = async ( idArquivo, variaveisGlobais, values,
    obterArquivoList ) => {

    if (!AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)) {

        const status = await deleteArquivoArquivoAcesso(variaveisGlobais,
            ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais), idArquivo)

        if (status) {

            await obterArquivoList(values)
        }
    }
}